<div class="">
  <div class="container-fluid content-bg">
    <div class="card card-login mx-auto mt-5">
      <div class="card-header">Change Password
        <button type="button" class="close" data-dismiss="modal" (click)=changeClose()>&times;</button>
      </div>
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="changePwd()" class="form-styles">
          <div class="form-group">
            <div class="form-row">
              <div class="col-md">
                <label for="first">Your Name</label>
                <input type="first" class="form-control" id="first" name="first" placeholder="{{userName}} "
                  value="{{userName}}" disabled readonly>
              </div>
            </div><br>
            <div class="form-row">
              <div class="col-md">
                <label for="email">Email</label>
                <input type="email" class="form-control" id="email" name="email" value="{{userEmail}}"
                  placeholder="{{userEmail}}" disabled readonly>
              </div>
            </div><br>
          </div>

          <div class="form-group">
            <div class="form-row">

              <div class="col-md">
                  <label for="passwordNew">New Password</label>
                  <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
                    <input type="password" class="form-control" formControlName="new_password"  title="Please re-enter your password"  pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$">
                </show-hide-password>

                <div *ngIf="form.get('new_password').dirty || form.get('new_password').touched" class="help-block">
                  <p *ngIf="form.get('new_password').hasError('required') && form.get('new_password').touched" style="color: red;">
                    Password must be required</p>
                  <p *ngIf="form.get('new_password').hasError('pattern') && form.get('new_password').touched" style="color: red;">
                    Password must be 1 capital , 1 small , 1 number and min 8 chars</p>
                </div>
              </div>
            </div><br>

            <div class="form-row">

              <div class="col-md">

                  <label for="passwordNew">Confirm Password</label>
                  <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
                    <input id="cnf_password" type="text" name="cnf_password"
                     formControlName="cnf_password"
                     pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$" 
                      value="{{cnf_password}}"> 
                  </show-hide-password>

                  <div *ngIf="form.get('cnf_password').dirty || form.get('cnf_password').touched" class="help-block">
                      <p *ngIf="form.get('cnf_password').hasError('required') && form.get('cnf_password').touched" style="color: red;">
                        Password must be required</p>
                      <p *ngIf="form.get('cnf_password').hasError('pattern') && form.get('cnf_password').touched" style="color: red;">
                        Password must be 1 capital , 1 small , 1 number and min 8 chars</p>
                    </div>
              </div>


            </div>

          </div>

          <div>
            <button class="btn btn-styles btn-primary" type="submit" [disabled]="!form.valid"
              style="width: 100%;">Submit</button>
          </div>

          <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button> -->
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="forgotpasswordModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Forgot Your Password ?</h5>
          <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="forgotpassword" name="forgotpassword" id="forgotpassword">
            <strong>Email</strong><br />
            <input type="text" id="emailForgot" name="emailForgot" class="form-control" placeholder="Enter Email">
            <span id="errmesg" style="color:red"></span>
            <div class="modal-footer">
              <span id="succMsg1" class="successMsg"></span>
              <span id="errMsg1" class="failMsg"></span>
              <button class="btn btn-success" id="submit">Send</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
    <p style="color: white">Loading </p>  
    </ngx-spinner>
</div>